export default "__VITE_ASSET__a64d7947__"